<!-- 网站优势 -->
<template>
  <div class="dip bgBox">
    <div class="conBox">
      <div class="keyAdvantagesBox">
        <div class="keyAdvantagesItem">
          <div class="headIconBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512111736685235.svg"
              alt=""
            />
          </div>
          <div class="keyAdvantagesItemH2">
            {{ $fanyi("具有经过验证的供应商的无限目录") }}
          </div>
          <div class="keyAdvantagesItemCon">
            {{ $fanyi("进入世界上最大的批发市场，发现它提供的所有机会。") }}
          </div>
        </div>

        <div class="keyAdvantagesItem">
          <div class="headIconBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512111733492683.svg"
              alt=""
            />
          </div>
          <div class="keyAdvantagesItemH2">
            {{ $fanyi("与中国直接联系") }}
          </div>
          <div class="keyAdvantagesItemCon">
            {{
              $fanyi(
                "在这个过程的每个阶段控制你的货物。我们在中国和意大利的基础设施使进口的实时跟踪成为可能。"
              )
            }}
          </div>
        </div>

        <div class="keyAdvantagesItem">
          <div class="headIconBox">
            <img
              src=" https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512111729608445.svg"
              alt=""
            />
          </div>
          <div class="keyAdvantagesItemH2">
            {{ $fanyi("个性化客户服务") }}
          </div>
          <div class="keyAdvantagesItemCon">
            {{
              $fanyi(
                "我们的专家团队将用意大利语回答您的所有问题，并指导您完成进口的每一步。"
              )
            }}
          </div>
        </div>

        <div class="keyAdvantagesItem">
          <div class="headIconBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512111724331569.svg"
              alt=""
            />
          </div>
          <div class="keyAdvantagesItemH2">
            {{ $fanyi("定制的商业体验") }}
          </div>
          <div class="keyAdvantagesItemCon">
            {{
              $fanyi(
                "定制您从中国进口的产品。选择您需要的产品，并根据您的具体需求定制服务。"
              )
            }}
          </div>
        </div>
      </div>
      <div class="weMadeBox" v-html="$fanyi(madeTogetherHtmlKey)"></div>

      <div class="flll33 cooperationBox">
        <div class="mask"></div>
        <div class="swiper-wrapper">
          <div class="swiper-slide dip" v-for="(it, oin) in imgList" :key="oin">
            <img :src="it" alt="" :class="`swImg${oin}`" width="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
export default {
  data() {
    return {
      madeTogetherHtmlKey:
        '我们<span style="color: #009246;">一起</span>创造独一无二的体验。',
      imgList: [
        // UPS
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260618162352614641.svg",
        // 1688
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202410/6717086ab4dfa.png",
        // alibaba
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260618162351124875.svg",
        // rakumart
        "https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202412/676a24056f038.svg",
      ],
    };
  },
  components: {},
  computed: {},
  created() {},
  mounted() {
    this.getSwiper();
  },
  methods: {
    getSwiper() {
      this.swiper = new Swiper(".flll33", {
        loop: true, // 无缝
        autoplay: {
          // 自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        slidesPerView: "auto",
        // slidesPerView: "4", 一组多少个
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 30, // 间隔
        // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
        observer: true,
        observeParents: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.bgBox {
  background: #f9fafb;
}
.conBox {
  width: 1400px;
  padding: 0px 0 54px;

  .keyAdvantagesBox {
    display: flex;
    justify-content: space-between;

    margin-bottom: 56px;

    .keyAdvantagesItem {
      padding: 32px 30px;
      width: 335px;
      min-height: 368px;
      border-radius: 16px;
      border: 2px solid var(--Gray-200, #eaecf0);
      background: #fff;

      .headIconBox {
        img {
          width: 56px;
        }
        margin-bottom: 16px;
      }

      .keyAdvantagesItemH2 {
        color: #013b2d;
        font-size: 30px;
        font-weight: 700;
        line-height: 38px; /* 126.667% */
        margin-bottom: 16px;
      }

      .keyAdvantagesItemCon {
        font-size: 18px;
        color: #344554;
        line-height: 28px; /* 155.556% */
      }
    }
  }

  .weMadeBox {
    font-size: 36px;
    font-weight: 600;
    line-height: 44px;
    text-align: center;
    margin-bottom: 25px;
    letter-spacing: -0.72px;
    color: #013b2d;
  }

  .cooperationBox {
    width: 1400px;
    position: relative;
    pointer-events: none;
    overflow: hidden;
    background-color: #f8faf9;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
        90deg,
        rgba(#f8faf9, 0.9) 0%,
        rgba(#f8faf9, 0.3) 40%,
        rgba(#f8faf9, 0.3) 50%,
        rgba(#f8faf9, 0.9) /* 这里不要有, */
      );
      z-index: 2;
    }
    .swiper-slide {
      width: min-content !important;
      height: 96px;
      margin-right: 96px !important;
    }
  }
}

.swImg3 {
  width: 200px;
}
</style>
